import { deleteObject, ref } from 'firebase/storage'
import { storage } from '../firebase-init'

export async function deleteAssetFromStorage(path?: string) {
  return deleteObject(ref(storage, path))
}
